export default "__VITE_ASSET__067071c5__"